(function ($) {

  'use strict';

  Drupal.behaviors.analytics = {
    attach: function (context, settings) {
      $(once('butterball_analytics_functions', 'body', context)).each(function () {

        // Generic Google Analytics tracking
        // eslint-disable-next-line
        $(once('analytics', '.js-tracking')).click(function () {
          var category = $(this).data('category').length ? $(this).data('category') : null;
          var label = $(this).data('label').length ? $(this).data('label') : null;
          var action = $(this).data('action').length ? $(this).data('action') : null;
          // eslint-disable-next-line
          if(typeof dataLayer !== 'undefined') {
            dataLayer.push({
              event: 'Click - buttontype',
              event_params: {
                eventCategory: category,
                eventTarget: label,
                eventAction: action
              }
            });
          }
          else {
            // eslint-disable-next-line
            console.error('Google Analytics "dataLayer" is missing');
          }

        });
      });
    }
  };
})(jQuery, Drupal, drupalSettings);

// # sourceMappingURL=maps/analytics.js.map
